import { Component, OnInit } from '@angular/core';
import { supervisoryagreement } from '../reports/view/reports-view.model';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ReportTableService } from '../reports/view/reports-view.service';
import { PrintService } from '../print-layout';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-supervisoryagreementlink',
  templateUrl: './supervisoryagreementlink.component.html',
  styleUrls: ['./supervisoryagreementlink.component.scss']
})
export class SupervisoryagreementlinkComponent implements OnInit {
  rowIds: string[];
  rowId:number;
    supervisoryagreementlist:supervisoryagreement[]=[];
    isPrint=false;
  constructor(private route: ActivatedRoute,private supervisoryagreementprintService:ReportTableService,
          private toastr: ToastrService,private printService: PrintService, private http: HttpClient  ) {
      this.rowIds = route.snapshot.params['Id']
      .split(',');
      this.rowId = +this.rowIds[0]; 
      console.log(this.rowId);
     }

  ngOnInit() {

    { 
      this.supervisoryagreementprintService.getRecruitsSupervisoryAgreementList(Number(this.rowId))
      // this.supervisoryagreementprintService.getRecruitsSupervisoryAgreementList()
      .toPromise()
      .then(res => {
        this.supervisoryagreementlist = res;
        // console.log(res);
        // Check if there is data to display
        if (this.supervisoryagreementlist.length > 0) {
          this.isPrint = true; // Enable data display
          // Comment out or remove this print-related line if you don't want the print functionality
          // this.printService.onDataReady(true,'Which clinician is allocated to work at a specific health center?')
          
          setTimeout(() => {
            this.isPrint = false; // Show the div again after setting it to true
          }, 100);
        } else {
          this.toastr.error('No data to display', '');
          // Remove the print functionality related line as well
          // this.printService.onDataReady(true,'Which clinician is allocated to work at a specific health center?','pdf','',1)
        }
      })
      .catch(err => { console.log(err); });
       
     }

  }

}
